"use client"

import { Col, Row } from "antd"
import { CSSProperties, FC, ReactNode } from "react"
export type PageFooterMobileProps = {
  content?: ReactNode,
  style?: CSSProperties
}

const PageFooterMobile: FC<PageFooterMobileProps> = ({ content = <></>, style }) => {
  return (
    <>
      <Row align='middle' justify='space-between' className="page__footer">
        <Col span={24} className="page__footer--content" style={style}>
          <Row align='middle' justify='space-between'>
            {content}
          </Row>
        </Col>
      </Row>
    </>
  )
}

export default PageFooterMobile